import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import * as platformAdminApi from '../services/platformAdminApi';
import FormField, { inputStyle } from '../components/FormField';
import Button from '../components/Button';

export default function PlatformAdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await platformAdminApi.login(email, password);
      navigate('/platform-admin', { replace: true });
    } catch (err) {
      setError(err.message || 'Could not sign in.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--color-bg)', padding: 'var(--space-4)',
    }}
    >
      <div style={{
        width: '100%', maxWidth: 380, background: 'var(--color-surface)',
        border: '1px solid var(--color-border)', borderRadius: 'var(--radius-md)',
        padding: 'var(--space-6)',
      }}
      >
        <div style={{
          fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', color: 'var(--color-text-muted)',
          textTransform: 'uppercase', marginBottom: 4,
        }}
        >
          Platform Admin
        </div>
        <h1 style={{ margin: '0 0 4px', fontSize: 'var(--font-size-xl)' }}>Sign in</h1>
        <p style={{ color: 'var(--color-text-secondary)', fontSize: 'var(--font-size-sm)', marginTop: 0 }}>
          Manage companies, licenses and user limits across the platform.
        </p>

        <form onSubmit={handleSubmit}>
          <FormField label="Email">
            <input
              type="email"
              required
              autoFocus
              style={inputStyle}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormField>
          <FormField label="Password">
            <input
              type="password"
              required
              style={inputStyle}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </FormField>
          {error && <p style={{ color: 'var(--color-danger)', fontSize: 'var(--font-size-sm)' }}>{error}</p>}
          <Button type="submit" disabled={submitting} style={{ width: '100%' }}>
            {submitting ? 'Signing in...' : 'Sign in'}
          </Button>
        </form>

        <p style={{ marginTop: 'var(--space-5)', fontSize: 'var(--font-size-xs)', color: 'var(--color-text-muted)', textAlign: 'center' }}>
          This is separate from the regular company login. It is only for managing
          which companies can use this software.
        </p>
      </div>
    </div>
  );
}
